module.exports = __webpack_public_path__ + "static/media/YF103_4.3905d38f.jpg";